export default __webpack_public_path__ + "8003dc8ce47dd77bd0187ce80345024b.png";